import Api from 'client/api/v2/Api';

/**
 * @typedef {Object} UserPortalTotpConfig - Configuration for TOTP in the User Portal
 * @property {boolean} enabled - Is TOTP enabled?
 */
class TotpApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/userportal/mfa/totp';
  }

  /**
   * @returns {UserPortalTotpConfig}
   */
  async getUserPortalTotpConfig() {
    await this.initialize();
    const response = await this.axios.get(this.baseUrl);
    return response.data;
  }

  /**
   * @param {UserPortalTotpConfig} config - changes to the TOTP User Portal Config
   */
  async saveUserPortalTotpConfig(config) {
    await this.initialize();
    const response = await this.axios.put(this.baseUrl, {
      enabled: config.enabled,
    });
    return response.data;
  }
}

export default new TotpApi();
